import { chatMessagingPolicy } from './chat-messaging.js';
import { insightEdgeFullAccessPolicy, insightEdgeReadOnlyPolicy } from './insightedge.js';
import { defineBuiltinRole } from './types.js';

/** A person who can look at everything in InsightEdge but change nothing. */
export const insightEdgeViewerRole = defineBuiltinRole({
  key: 'builtin:ie-viewer',
  name: 'InsightEdge Viewer',
  description: 'A person using InsightEdge who can view everything but not change or publish anything.',
  policies: [insightEdgeReadOnlyPolicy, chatMessagingPolicy],
});

/** A person who can do everything in InsightEdge: view, create, change and publish. */
export const insightEdgeAdminRole = defineBuiltinRole({
  key: 'builtin:ie-admin',
  name: 'InsightEdge Admin',
  description: 'A person using InsightEdge who can view, create, change and publish everything.',
  policies: [insightEdgeFullAccessPolicy, chatMessagingPolicy],
});
